<template>
<div class="input">

  <label class="mdc-text-field input__field mdc-text-field--outlined mdc-text-field--with-trailing-icon"
         :class="{
       'mdc-text-field--valid': validState,
       'mdc-text-field--disabled': disabled,
       'mdc-text-field--invalid': invalid
      }">
    <bk-outline-notched :label="label" :id="id"/>
    <input :value="trimmedValue"
           @input="$emit('input', $event.target.value)"
           @change="$emit('change',$event.target.value)"
           @focus="$emit('focus')"
           @blur="$emit('blur')"
           :disabled="disabled"
           :type="type"
           :id="id"
           class="mdc-text-field__input"
           :aria-controls="helperTextId"
           :aria-describedby="helperTextId"
           :maxlength="maxLength"
           autocomplete="off"
           :class="{
             'data-hj-allow': allowHotjarRecording,
             'data-hj-suppress': !allowHotjarRecording
           }"
    >
    <i v-if="loading" class="mdc-text-field__icon mdc-text-field__icon--trailing" tabindex="-1">
      <bk-loading-spinner></bk-loading-spinner>
    </i>
    <i v-else class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing" tabindex="0" role="button">{{ icon }}</i>
  </label>
  <div class="mdc-text-field-helper-line">
    <p :id="helperTextId"
       class="mdc-text-field-helper-text mdc-text-field-helper-text--persistent mdc-text-field-helper-text--validation-msg"
       :class="{'mdc-text-field-helper-text--disabled': !showHelper}"
       aria-hidden="true"
    >{{helperText}}</p>
  </div>
</div>
</template>

<script>
import { MDCTextField } from '@material/textfield'
import BkInputLabel from './BkInputLabel'
import BkOutlineNotched from './BkOutlineNotched'
import BkLoadingSpinner from './BkLoadingSpinner'

export default {
  name: 'bk-input',
  data () {
    return {
      inputFoundation: null,
    }
  },
  components: { BkInputLabel, BkOutlineNotched, BkLoadingSpinner },
  props: {
    /**
     * Allow recording in HotJar by setting the appropriate classes to the input field
     */
    allowHotjarRecording: {
      type: Boolean,
      default: false
    },
    /**
     * If this is true the helper text is visible
     */
    showHelper: {
      type: Boolean,
      default: true,
    },
    /**
     * The trailing icon in the input
     */
    icon: String,
    /**
     * The label of the input
     */
    label: String,
    /**
     * The value of the input
     */
    value: [String, Number],
    /**
     * Type of the input
     */
    type: {
      type: String,
      default: 'text',
    },
    /**
     * Content of the helper text
     */
    helperText: String,
    /**
     * If true the input is valid
     */
    valid: {
      type: Boolean,
      default: true,
    },
    /**
     * If true the input is unchanged
     */
    pristine: {
      type: Boolean,
      default: true
    },
    /**
     * the id of the input
     */
    id: {
      type: String,
      required: true,
    },
    loading : {
       type: Boolean,
      default: false,
    },
    maxLength: {
      type: Number,
      default: 524288,
    },
    disabled: {
      type: Boolean,
      default: false
    },
    trim: {
      type: Boolean,
      default: true
    }
  },
  mounted () {
    this.inputFoundation = new MDCTextField(this.$el.querySelector('.mdc-text-field'))
    this.inputFoundation.useNativeValidation = false

  },
  computed: {
    /**
     * return true if the element is valid and dont pristine
     */
    validState () {
      let realValidState = this.valid && !this.pristine && !this.disabled;
      if( this.inputFoundation !== null && realValidState ) this.inputFoundation.valid = true;

      return realValidState;
    },
    invalid () {
      let realInvalidState = !this.valid && !this.pristine && !this.disabled;
      if( this.inputFoundation !== null && realInvalidState ) this.inputFoundation.valid = false;

      return realInvalidState;
    },
    trimmedValue(){
      return typeof this.value === 'string' && this.trim ? this.value.trim() : this.value;
    },
    /**
     * get the id for the helpertext
     * @returns {string}
     */
    helperTextId () {
      return `helper-text-${this.id}`
    },
  },
}
</script>

<style lang="scss" scoped>
  .input__field {
    width: 100%;
    max-width: 320px
  }
  .mdc-text-field-helper-text {
    margin-left: 0;
    margin-right: 0;

    &--disabled {
      display: none;
    }
  }

</style>
